import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { NakedButton, Icon, Flex, Text } from 'roo-ui/components';
import { themeGet } from 'styled-system';

const IconButton = styled(NakedButton)`
  position: relative;
  padding: ${themeGet('space.3')} ${themeGet('space.3')};
  font-size: ${themeGet('fontSizes.base')};
  line-height: ${themeGet('lineHeights.normal')};
  border: ${themeGet('borders.1')} ${themeGet('colors.greys.alto')};
  border-radius: ${themeGet('radii.default')};
  border-color: ${(props) => (props.hasFilters ? themeGet('colors.brand.secondary')(props) : themeGet('colors.greys.alto')(props))};
  background-color: ${(props) => (props.hasFilters ? themeGet('colors.ui.infoBackground')(props) : themeGet('colors.white')(props))};
  display: flex;
  justify-content: center;
  width: 100%;

  &:focus {
    outline: 0;
    border-color: ${themeGet('colors.blue')};
    box-shadow: 0 0 0 1px ${themeGet('colors.blue')};
    background-color: ${themeGet('colors.lightBlue')};
  }
`;
IconButton.displayName = 'Button';

const TransparentButton = styled(IconButton)`
  background-color: transparent;
  color: ${themeGet('colors.white')};
  box-shadow: none;
  padding: 0;
  width: 126px;
  height: 48px;
  align-items: center;
  border: none;

  &:focus {
    background-color: transparent;
  }
`;

const FilterCount = styled(Flex)`
  position: absolute;
  top: -${themeGet('space.1')};
  right: -${themeGet('space.1')};
  background: ${themeGet('colors.brand.primary')};
  border-radius: ${themeGet('radii.rounded')};
  width: ${themeGet('space.5')};
  height: ${themeGet('space.5')};
  line-height: ${themeGet('space.5')};
  font-size: ${themeGet('fontSizes.xs')};
  align-items: center;
  justify-content: center;
`;

FilterCount.displayName = 'FilterCount';

const FiltersButton = ({ label, count, onClick }) => {
  const hasFilters = count > 0;

  return (
    <TransparentButton hasFilters={hasFilters} onClick={onClick} data-testid="filters-button" verticalAlign="center">
      <Flex alignItems="center">
        <Icon name="tune" />

        <Text ml={2} fontSize="md">
          {label}
        </Text>

        {hasFilters && <FilterCount>{count}</FilterCount>}
      </Flex>
    </TransparentButton>
  );
};

FiltersButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  count: PropTypes.number,
};

FiltersButton.defaultProps = {
  label: 'Filters',
  count: 0,
};

export default FiltersButton;
